import React from "react";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ReactPaginate from 'react-paginate';
import axios from "axios";
import ImageModal from "../KYC/ImageModal";

const PinRequest = () => {


  const [vendorkyc, updateKyc] = useState([]);
  const [pinRequest, setPinRequest] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const baseUrl = `https://apimlm.bloomitsolutions.in`;
  console.log("pinRequest1233", pinRequest);
  const getPinrequest = async () => {

    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/pingeneration//pin-request/all"
      );
      const empData = response.data;
      setPinRequest(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };



  const updateKycStatus = (id, status) => {
    const updatedKyc = vendorkyc.map((pinRequest) =>


      pinRequest.id === id ? { ...pinRequest, status } : pinRequest


    );
    updateKyc(updatedKyc);

  };

  const acceptKyc = (id) => {


    axios.put(`https://apimlm.bloomitsolutions.in/pingeneration/pin-request?requestId=${id}`, {
      "action": "approve"
    })

    updateKycStatus(id, "Approved");
    toast(id + "Approved Successfully");

  };

  const declineKyc = (id) => {
    // Send a PUT request to update the status to "Rejected"
    axios.put(`https://apimlm.bloomitsolutions.in/pingeneration/pin-request?requestId=${id}`, {
      "action": "reject"
    })
      .then((response) => {
        if (response.status === 200) {
          // If the status update was successful, update the local state
          updateKycStatus(id, "Rejected");
          toast(id + " Declined Successfully");
        } else {
          toast.error("Failed to decline the request. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error declining the request: ", error);
        toast.error("An error occurred while declining the request.");
      });
  };


  useEffect(() => {
    getPinrequest();
  }, []);

  const newPinRequests = pinRequest.filter((request) => request.status === "Pending");

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentRequests = pinRequest.slice(indexOfFirstItem, indexOfLastItem);

  // const paginate = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  //pagination start
  const PER_PAGE = 5;
  const [currentPage, setCurrentPage] = useState(0);
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage)
  }
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(pinRequest.length / PER_PAGE);

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };


  return (
    <section>

      <div className="container-fluid">

        <ToastContainer />
        <div className="row ">
          <div className="col-lg-12 ">
            <div className="row " style={{ display: "flex" }}></div>
            <div className="row ">
              <div className="col-lg-6 mt-4  "></div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-12">
                <div className="card">
                  <div
                    className="card-header"
                    style={{
                      backgroundColor: "rgb(0,156,216)",
                      color: "white",
                    }}
                  >
                    <h4> PIN Request</h4>
                  </div>
                  <div className="card-body">
                    {/* <div className="">
                        <ButtonGroup className="mb-2">
                          <Button>Copy </Button>
                          <Button>Excel</Button>
                          <Button>PDF</Button>
                          <Button>Column visibility</Button>
                        </ButtonGroup>
                      </div> */}
                    <form>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Sl No</th>
                                <th scope="col">User Id</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Transaction Number</th>
                                <th scope="col">Image</th>
                                <th scope="col">Status</th>
                                {/* <th scope="col">Pins</th> */}
                                {/* {/ Remove 'createdAt' and 'updatedAt' columns /} */}
                                <th scope="col">Action</th>
                                {/* <th>Reconsider</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {newPinRequests.slice(offset, offset + PER_PAGE).map((product, index) => (
                                <tr key={index}>
                                  <td>{product.id}</td>
                                  <td>{product.userId}</td>
                                  <td>{product.amount}</td>
                                  <td>{product.transactionNumber}</td>
                                  <td>
                                    <img
                                      src={`${baseUrl}/${product.imagepath}`}
                                      className="img-fluid"
                                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                                      onClick={() => openImageModal(`${baseUrl}/${product.imagepath}`)}
                                      alt="Product"
                                    />
                                  </td>
                                  <td className={product.status === 'Approved' ? 'text-success' : product.status === 'Rejected' ? 'text-danger' : ''}>{product.status}</td>
                                  {/* <td>{product.pin}</td> */}
                                  <td>
                                    {product.status === 'Used' ? (
                                      <button
                                        className="btn btn-warning mx-2"
                                      >
                                        Used
                                      </button>
                                    ) : (
                                      <>
                                        {product.status !== 'Rejected' && (
                                          <button
                                            className="btn btn-success mx-2 mt-1"
                                            onClick={() => acceptKyc(product.id)}
                                          >
                                            Approve
                                          </button>
                                        )}
                                        {product.status !== 'Approved' && (
                                          <button
                                            className="btn btn-danger mx-2 mt-1"
                                            onClick={() => declineKyc(product.id)}
                                          >
                                            Decline
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  {/* <td>
                                    {product.status === 'Used' ? (
                                      <button
                                        className="btn btn-warning mx-2"
                                      >
                                        Used
                                      </button>
                                    ) : (
                                      <>
                                        {product.status !== 'Approved' && (
                                          <button
                                            className="btn btn-success mx-2"
                                            onClick={() => acceptKyc(product.id)}
                                          >
                                            Approve
                                          </button>
                                        )}
                                        {product.status !== 'Rejected' && (
                                          <button
                                            className="btn btn-danger mx-2"
                                            onClick={() => declineKyc(product.id)}
                                          >
                                            Decline
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div className="mb-4 mt-4">
                            <ReactPaginate
                              previousLabel={"Previous"}
                              nextLabel={"Next"}
                              breakLabel={"..."}
                              pageCount={pageCount}
                              marginPagesDisplayed={5}
                              pageRangeDisplayed={3}
                              onPageChange={handlePageClick}
                              containerClassName={"pagination  justify-content-center"}
                              pageClassName={"page-item "}
                              pageLinkClassName={"page-link"}
                              previousClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextClassName={"page-item"}
                              nextLinkClassName={"page-link"}
                              breakClassName={"page-item"}
                              breakLinkClassName={"page-link"}
                              activeClassName={"active primary"}
                            />
                          </div>

                          {/* <nav aria-label="...">
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <a className="page-link" onClick={() => paginate(currentPage - 1)}>
                Previous
              </a>
            </li>
            {Array.from({ length: Math.ceil(pinRequest.length / itemsPerPage) }, (_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                <a className="page-link" onClick={() => paginate(index + 1)}>
                  {index + 1}
                </a>
              </li>
            ))}
            <li className={`page-item ${currentPage === Math.ceil(pinRequest.length / itemsPerPage) ? "disabled" : ""}`}>
              <a className="page-link" onClick={() => paginate(currentPage + 1)}>
                Next
              </a>
            </li>
          </ul>
        </nav> */}
                        </div>
                      </div>
                      {/* {/ /.card-body /} */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}
    </section>
  );
};

export default PinRequest;


